import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from '../helpers/responseMapper.function';

@Injectable()

export class HomeService {

    constructor(private httpClient : HttpClient) {
    }

    setHomeHubValues(values) {
        (function (t, w: any, d, polizaIframe) {
            if (values && values.poliza) {
                w.poliza = values.poliza;
                if (polizaIframe) {
                    polizaIframe['contentWindow'].poliza = values.poliza;
                }
            }
        })(this, window, document, document.querySelector('#polizaIframe'));
    }

    getSettingsWelcomeModal(userId): Observable<any> {
        return this.httpClient.get(environment.server.api.car + '/api/settings?userId=' + userId + '&changeMustShowWelcomeBanner=true').pipe(
            map(mapResponseWithData));
    }

    getShowNewsModal() {
        return this.httpClient.get(environment.server.api.auth + '/api/news/portalpas');
    }

    sendMsg(w, values: any) {
        if (w) {
            w.postMessage(values, '*')
        }
    }

    getUserSettings(): Observable<any> {
        return this.httpClient.get(`${environment.server.api.typeList}/api/BranchOfficeSettings/user`).pipe(
            map(mapResponseWithData));
    }

    putNewsReadedForUserLogged() {
        return this.httpClient.post(environment.server.api.auth + '/api/news/portalpas', {}).pipe(
            map(mapResponseWithData));
    }
}
